module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b9wAq"))).then(() => parcelRequire('cvs7o'));